import { useState } from "react";
import { TextInput } from "@mantine/core";
import { Check, ChevronDown, Search, Users } from "lucide-react";
import { Button, Sheet } from "./ui";

type TeamChoice = { id: string; name: string; count: number };

export default function MemberTeamFilter({
  teams,
  value,
  total,
  opened,
  onOpenedChange,
  onChange,
}: {
  teams: TeamChoice[];
  value: string;
  total: number;
  opened: boolean;
  onOpenedChange: (opened: boolean) => void;
  onChange: (id: string) => void;
}) {
  const [query, setQuery] = useState("");
  const selected = teams.find((team) => team.id === value);
  const matching = teams.filter((team) =>
    team.name.toLocaleLowerCase().includes(query.trim().toLocaleLowerCase()),
  );
  const choose = (id: string) => {
    onChange(id);
    onOpenedChange(false);
  };
  return (
    <>
      <Button
        className={`member-team-trigger${selected ? " is-filtered" : ""}`}
        aria-label={`按 GitHub 团队筛选，当前${selected?.name || "全部团队"}`}
        aria-haspopup="dialog"
        aria-expanded={opened}
        onClick={() => {
          setQuery("");
          onOpenedChange(true);
        }}
      >
        <Users size={18} aria-hidden="true" />
        <span className="member-team-label">团队</span>
        <span className="member-team-value">
          {selected?.name || "全部团队"}
        </span>
        <ChevronDown size={16} aria-hidden="true" />
      </Button>
      {opened ? (
        <Sheet title="选择团队" compact onClose={() => onOpenedChange(false)}>
          <div className="member-team-picker">
            <TextInput
              leftSection={<Search size={18} />}
              aria-label="搜索 GitHub 团队"
              placeholder="搜索团队"
              value={query}
              onChange={(event) => setQuery(event.currentTarget.value)}
            />
            <div className="member-team-options" aria-label="GitHub 团队">
              <Button
                className="member-team-option"
                aria-pressed={!value}
                onClick={() => choose("")}
              >
                <span>全部团队</span>
                <small>{total} 人</small>
                {!value ? <Check size={18} aria-hidden="true" /> : null}
              </Button>
              {matching.map((team) => (
                <Button
                  key={team.id}
                  className="member-team-option"
                  aria-pressed={value === team.id}
                  onClick={() => choose(team.id)}
                >
                  <span>{team.name}</span>
                  <small>{team.count} 人</small>
                  {value === team.id ? (
                    <Check size={18} aria-hidden="true" />
                  ) : null}
                </Button>
              ))}
            </div>
            {query && !matching.length ? (
              <p className="member-team-empty">
                没有匹配的团队，试试其他名称。
              </p>
            ) : null}
            {!teams.length ? (
              <p className="member-team-empty">当前项目还没有 GitHub 团队。</p>
            ) : null}
          </div>
        </Sheet>
      ) : null}
    </>
  );
}
